/**
 * StageMovePrompt — public entry point for the sensitive-stage reason prompt
 * (SE-5495). The prompt is fully controlled: all state lives in
 * `useStageMovePrompt`, and the Container owns no state either — it binds the
 * per-outcome handlers and the reason gate the View may not derive itself
 * (SE-8019).
 * @module features/player-kanban/components/molecules/StageMovePrompt
 */

export { default } from "./StageMovePromptContainer";
export type { StageMovePromptContainerProps } from "./StageMovePromptContainer";
export type { StageMovePromptViewProps } from "./StageMovePromptView";
